var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenShelters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OPEN_SHELTERS",
    "data-name": "OPEN SHELTERS",
    transform: "translate(-1375 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4270",
    "data-name": "Rectangle 4270",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(1375 169)",
    fill: "#fff0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hut",
    d: "M42.087,32.5h-.809a8.225,8.225,0,0,0-6.724-6.724v-7.1c.885-.323,1.765-.668,2.63-1.061l.675-.307a1.369,1.369,0,0,0,.31-2.3l-13.8-11.5.107-.089a1.369,1.369,0,0,0-1.753-2.1l-.493.41-.493-.411a1.37,1.37,0,1,0-1.754,2.1l.107.089-13.8,11.5a1.37,1.37,0,0,0,.31,2.3l.675.307c.866.394,1.746.739,2.631,1.061v7.1A8.226,8.226,0,0,0,3.178,32.5H2.37a1.37,1.37,0,1,0,0,2.739H5.109v6.848a1.37,1.37,0,1,0,2.739,0V35.239h8.217v6.848a1.37,1.37,0,1,0,2.739,0v-1.37h6.848v1.37a1.37,1.37,0,1,0,2.739,0V35.239h8.217v6.848a1.37,1.37,0,1,0,2.739,0V35.239h2.739a1.37,1.37,0,1,0,0-2.739ZM22.228,5.293,34.715,15.7A33.149,33.149,0,0,1,22.228,18.12,33.149,33.149,0,0,1,9.742,15.7ZM5.967,32.5A5.5,5.5,0,0,1,9.9,28.565V32.5Zm6.675-12.933q1.02.281,2.054.5v1.476a1.37,1.37,0,1,0,2.739,0V20.531a36.308,36.308,0,0,0,4.794.328,36.308,36.308,0,0,0,4.794-.328v1.013a1.37,1.37,0,1,0,2.739,0V20.068q1.034-.22,2.054-.5V32.5H27.022V27.022a2.742,2.742,0,0,0-2.739-2.739H20.174a2.742,2.742,0,0,0-2.739,2.739V32.5H12.641ZM24.283,32.5H20.174V27.022h4.109Zm1.37,5.478H18.8V35.239h6.848Zm8.9-5.478V28.565A5.5,5.5,0,0,1,38.49,32.5Z",
    transform: "translate(1399 193)",
    fill: "#c3504f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenShelters);
export default __webpack_public_path__ + "static/media/OPEN-SHELTERS.2ed3e41cb5917f740e68a3cf49f5aa27.svg";
export { ForwardRef as ReactComponent };